/** */
import { urls } from './_url';
import { apiGet } from './_http';

/** */
const base_url = `${urls.mailometric}/links`;

export const read = async (options = {}) => {
  return await apiGet(`${base_url}`, { ...options });
};

export const readById = async (id, options = {}) => {
  return await apiGet(`${base_url}/${id}`, { ...options });
};
